module.exports = __webpack_public_path__ + "media/src/public/images/mail/pretty/calendar-f24bad6b4c9f02884415db2ea2f94087.png";